import { render, staticRenderFns } from "./td-index-as-value.vue?vue&type=template&id=5bb6f0fb"
import script from "./td-index-as-value.vue?vue&type=script&lang=js"
export * from "./td-index-as-value.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports